import axios from 'axios';
import { API, authHeaders } from './client';

export const getOrders = (token, params) =>
  axios.get(`${API}/orders`, { params, ...authHeaders(token) }).then(r => r.data);

export const resendEmail = (token, orderId, email) =>
  axios.post(`${API}/orders/${orderId}/resend-email`, email ? { email } : {}, authHeaders(token)).then(r => r.data);
